// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 20vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}
@keyframes slideAndFade {
  0% {
    transform: translateX(-150px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.animate-text {
  animation: slideAndFade 1.5s ease-out forwards;
  display: none; /* Ensure it's visible */
}
.list-item-animate-delay-1 {
  animation-delay: 0.1s;
}
.list-item-animate-delay-2 {
  animation-delay: 0.2s;
}
.list-item-animate-delay-3 {
  animation-delay: 0.3s;
}
.list-item-animate-delay-4 {
  animation-delay: 0.4s;
}
.list-item-animate-delay-5 {
  animation-delay: 0.5s;
}
.App-header {
  background-color: black;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}
.fanoos-text {
  font-family: "fanoos" !important;
  font-size: 1.2rem; /* text-2xl equivalent */
  font-weight: bold;
  width: fit-content;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;AACA;EACE;IACE,6BAA6B;IAC7B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,8CAA8C;EAC9C,aAAa,EAAE,wBAAwB;AACzC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,gCAAgC;EAChC,iBAAiB,EAAE,wBAAwB;EAC3C,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 20vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n@keyframes slideAndFade {\n  0% {\n    transform: translateX(-150px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.animate-text {\n  animation: slideAndFade 1.5s ease-out forwards;\n  display: none; /* Ensure it's visible */\n}\n.list-item-animate-delay-1 {\n  animation-delay: 0.1s;\n}\n.list-item-animate-delay-2 {\n  animation-delay: 0.2s;\n}\n.list-item-animate-delay-3 {\n  animation-delay: 0.3s;\n}\n.list-item-animate-delay-4 {\n  animation-delay: 0.4s;\n}\n.list-item-animate-delay-5 {\n  animation-delay: 0.5s;\n}\n.App-header {\n  background-color: black;\n  min-height: 50vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n.fanoos-text {\n  font-family: \"fanoos\" !important;\n  font-size: 1.2rem; /* text-2xl equivalent */\n  font-weight: bold;\n  width: fit-content;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
